import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/security/twoFactorStatus';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

const unwrap = (res) => (res && res.data && res.data.data !== undefined ? res.data.data : (res && res.data) || {});

function* operation() {
  try {
    const res = yield call(
      axios.get,
      `${config.API_URL}/user/2fa/status`,
      { headers: getLocalUser() },
    );
    yield put(fetchSuccess(unwrap(res)));
  } catch (err) {
    yield put(ErrorAction(err));
    const message = err?.response?.data?.data?.message
      || err?.response?.data?.message
      || 'Could not load security settings';
    yield put({ type: 'SHOW_ERROR_SNACKBAR', message });
    yield put(fetchFailure(message));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
